module.exports = __webpack_public_path__ + "static/media/fantasyomatic-ui-login-Artboard-2@2x.5418f9e1.png";